module.exports = __webpack_public_path__ + "static/loading-black-706b1c926b675631714cfc74c6f8d3a0.gif";